import type { LogoProps } from "../../sdk/theme";
import { overridable } from "../overrides";

// The Cloudmail logo: an envelope with a cloud rising out of it. The flap meets at an ember
// dot and a molten spark sits above the corner, the same accents as the Bytesforge mark.
export const LogoMark = ({ size = 24 }: { size?: number }) => (
  <svg
    class="logo-mark"
    width={size}
    height={size}
    viewBox="0 0 64 64"
    aria-hidden="true"
    focusable="false"
  >
    <g fill="var(--brand-blue)">
      <rect x="8" y="24" width="48" height="32" rx="7" />
      <circle cx="22" cy="21" r="8" />
      <circle cx="33" cy="16" r="10.5" />
      <circle cx="44" cy="22" r="7" />
    </g>
    <path
      d="M14 30 L32 43 L50 30"
      fill="none"
      stroke="#fff"
      stroke-width="4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <circle cx="32" cy="43" r="3.4" fill="var(--brand-ember)" />
    <path
      d="M55 3 L56.7 7.6 L61.3 9.3 L56.7 11 L55 15.6 L53.3 11 L48.7 9.3 L53.3 7.6 Z"
      fill="var(--brand-molten)"
    />
  </svg>
);

/** The mark and the app's name; "Cloudmail" gets the two-tone wordmark. */
const DefaultLogo = ({ appName, size = 26 }: LogoProps) => (
  <span class="logo" data-part="logo">
    <LogoMark size={size} />
    <span class="logo-word">
      {appName.toLowerCase() === "cloudmail" ? (
        <>
          <b>cloud</b>mail
        </>
      ) : (
        appName
      )}
    </span>
  </span>
);

export const Logo = overridable("Logo", DefaultLogo);
